import type { RulesLogic } from '@jira/polaris__domain-field/src/ValueDecoration.types.tsx';
import jsonLogic from '@jira/polaris__lib-json-logic/src/index.tsx';
import { isDateOverdueOption } from './isDateOverdueOption.tsx';

export const applyDateTimeLogic = (logic: RulesLogic, daysUntilDueDate: number): boolean => {
	return jsonLogic.apply(logic, { daysUntilDueDate });
};

type ApplyDateTimeRangeLogicPayload = {
	logic: RulesLogic;
	diffDaysBeforeStart: number;
	diffDaysBeforeEnd: number;
};

/**
 * For overdue date:
 * We check only the end days since the rules does not contain the start day.
 *
 * For coming soon date or the interval:
 * Such code `jsonLogic.apply(decoration.logic, { daysUntilDueDate: diffDaysBeforeStart }) || jsonLogic.apply(decoration.logic, { daysUntilDueDate: diffDaysBeforeEnd });`
 * does not work for range of dates like month or quarter since we really want to make an intersection between the range of days from value and from the logic.
 * So, I decided to do that manually, since other alternative solution like
 * `Array.from(...).some(daysUntilDueDate => jsonLogic.apply(logic, { daysUntilDueDate });` is not efficient for long ranges.
 */
export const applyDateTimeIntervalLogic = ({
	logic,
	diffDaysBeforeStart,
	diffDaysBeforeEnd,
}: ApplyDateTimeRangeLogicPayload): boolean => {
	if (isDateOverdueOption(logic)) {
		return applyDateTimeLogic(logic, diffDaysBeforeEnd);
	}

	const [gt, _, lt] = jsonLogic.get_values(logic);

	return diffDaysBeforeEnd > gt && diffDaysBeforeStart < lt;
};
